module.exports = __webpack_public_path__ + "static/media/Fredrico.26494bbb.png";